// src/shared/admin-token.js - ONE place the admin modules' raw fetches find the sign-in token (v136.12, 19 Oct 2026).
//
// An area manager on staging saw "Scan failed: HTTP 401: {"error":"Unauthorized"}" on Stores, Compliance. That
// screen (and a handful of others) built its own fetch with `sessionStorage.elcAdminToken` and nothing else, while
// the rest of the admin app goes through db.js, which holds the token in memory (DB.getToken()) and only falls back
// to sessionStorage. A tab whose sessionStorage copy is missing or older than the one db.js holds sends the wrong
// token (or none) and gets a 401 while the rest of the app works. And when the sign-in really has ended, the screen
// showed the raw HTTP text instead of saying so.
//
// The order is the one db.js itself uses, plus the remembered copy the sign-in keeps ("remember me", v124.89):
// DB.getToken() first, then this tab's sessionStorage, then localStorage. Each step is guarded: a page without DB,
// or a browser that blocks storage, falls through to the next and finally to ''. Server auth is unchanged.

export function adminToken() {
  try {
    if (typeof DB !== 'undefined' && DB && typeof DB.getToken === 'function') {
      const t = DB.getToken();
      if (t) return String(t);
    }
  } catch (e) { /* no DB on this page: fall through */ }
  try {
    const s = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('elcAdminToken') : '';
    if (s) return s;
  } catch (e) { /* storage blocked: fall through */ }
  try {
    const l = typeof localStorage !== 'undefined' ? localStorage.getItem('elcAdminToken') : '';
    if (l) return l;
  } catch (e) { /* storage blocked */ }
  return '';
}

// What a screen says when the Worker answers 401: the person's sign-in is no longer valid (expired, signed out
// elsewhere, or an acting period that has ended). Plain words instead of the raw HTTP text. Arabic in
// src/i18n/ar/admin-errors.js, keyed exactly as written here.
export const SIGNIN_EXPIRED_MESSAGE = 'Your sign-in has run out. Sign out and back in.';

export function isSignInExpired(status) {
  return Number(status) === 401;
}
